// zercode packages
import { permissionsHaveModule, useMe } from '@zercode/auth';
import { LANDING_CATALOG, landingOptionOf, landingPathsOf, resolveLandingRoute } from '@zercode/tenancy';

// project imports
import { APP_CODE } from './appCode';
import { useBrandingStore } from './brandingStore';
import { authApi } from './zercode';

// ==============================|| LANDING ROUTE (LAND-CFG) ||============================== //
// Kiracının ayarladığı açılış sayfasını çözer. AYRI BİR HOOK, çünkü iki ÇAĞIRAN var ve ikisi de
// AYNI hedefi vermek zorunda:
//   * `LandingRedirect` — `index` ve `*` catch-all route'ları (giriş sonrası ilk sayfa),
//   * `berry/layout/MainLayout/LogoSection` — sol üstteki site logosu.
// Logo eskiden sabit `DASHBOARD_PATH`'e gidiyordu, yani ayar girişte işliyor ama logoya basınca
// yok sayılıyordu. Mantık tek yerde durmazsa bu ayrışma kaçınılmaz olarak geri gelir.
//
// NEDEN HOOK, NEDEN MODÜL SABİTİ DEĞİL: route dizisi modül yüklenirken değerlendirilir, marka ise
// main.tsx'te `await` ile çözülür — modül seviyesinde okumak HER ZAMAN varsayılanı görürdü. Render
// anında store'dan okumak doğru değeri garanti eder (marka ilk boyamadan önce yerleşmiştir).
//
// İZİNLER GELENE KADAR `null`: `me` beklemedeyken ayarlanan sayfanın erişilebilirliği BİLİNEMEZ.
// O anda varsayılana düşmek yöneticinin ayarını rastgele yok saymak, ayarı geçirmek de 403 riski
// olurdu. Çağıran bu `null`'ı kendi bağlamına göre karşılar: yönlendirme bekler (hiçbir şey
// çizmez), logo ise SPA'nın sabit varsayılanına bağlanır — link zaten tıklanana kadar gitmez.

/** Çözülmüş açılış yolu; izinler henüz gelmediyse `null`. */
export function useLandingRoute(): string | null {
  const landingPages = useBrandingStore((s) => s.branding.landingPages);
  const meQuery = useMe(authApi);

  if (meQuery.isPending) {
    return null;
  }

  const permissions = meQuery.data?.permissions ?? [];
  const allowed = new Set(permissions);

  return resolveLandingRoute({
    configured: landingPages?.[APP_CODE],
    allowed: landingPathsOf(APP_CODE),
    fallback: LANDING_CATALOG[APP_CODE].default,
    // Menü gizlemeyle AYNI kural: tek izin VEYA modül üzerinde herhangi bir eylem (PA-7).
    isReachable: (path) => {
      const option = landingOptionOf(APP_CODE, path);
      if (!option) {
        return false;
      }
      if (option.permission && !allowed.has(option.permission)) {
        return false;
      }
      if (option.module && !permissionsHaveModule(permissions, option.module)) {
        return false;
      }
      return true;
    }
  });
}

/** Hook'un `null` döndüğü ana kadar kullanılacak sabit varsayılan (logo linki için). */
export const LANDING_FALLBACK = LANDING_CATALOG[APP_CODE].default;
